import { Injectable } from "@angular/core";
import { ProductType } from "@obg/core.config";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

const ACTION_PREFIX = "[App Context]";
export const APP_CONTEXT_ACTION_TYPE = {
	setProduct: `${ACTION_PREFIX} Set Product ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class AppContextAction {
	setProduct(payload: ProductType): ActionWithPayload {
		return {
			type: APP_CONTEXT_ACTION_TYPE.setProduct,
			payload,
		};
	}
}
